<template>
  <div>
    <div class="error" v-if="error">{{ error }}</div>
    <div class="playlist-details" v-if="document">
      <div class="playlist-info">
        <div class="cover">
          <img :src="document.coverUrl" :alt="document.title">
        </div>
        <h2 class="text-white">{{ document.title }}</h2>
        <p class="username text-white">Created by {{ document.userName}}</p>
        <p class="description text-white">{{ document.description }}</p>
        <button v-if="ownerShip" @click.prevent="deleteplaylist">Delete Playlist</button>
      </div>
      <div class="song-list">
        <div v-if="!document.songs.length">No songs have been added to this playlist yet.</div>
        <div v-for="song in document.songs" :key="song.id" class="single-song">
          <div class="details">
            <h3 class="text-white">{{ song.title }}</h3>
            <p class="text-white">{{ song.artist }}</p>
          </div>
          <button v-if="ownerShip" @click.prevent="deleteSong(song.id)">Delete</button>
        </div>
        <Addsong :playlist="document" v-if="ownerShip" />
        <div>
        <Commentwall  :id="id" />
      </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import Commentwall from '../../components/Commentwall'
import Addsong from '../../components/Addsong'
import getDocument from '../../composables/getDocument'
import getUser from '../../composables/getUser'
import useDocument from '../../composables/useDocument'
import useStorage from '../../composables/useStorage'
import { useRouter } from 'vue-router'
import { computed } from 'vue'
export default {
  props: ['id'],
  components: {
    Addsong,
    Commentwall
  },
  setup(props) {
    // 取得單一document
    const { error, document } = getDocument('playlists', props.id);
    const { user } = getUser();
    const router = useRouter();
    const { deleteDoc, updateDoc } = useDocument('playlists', props.id);
    const { deleteImag } = useStorage();
    // ownerShip 確認user是否為該playlist的creator ，true則可以做delete
    // 由於ownerShip會變動因此要用computed， 
    const ownerShip = computed(() => {
      // 確認document已經取得，且已經取得user及已登入
      return document.value && user.value && user.value.uid === document.value.userId;
    })
    const deleteplaylist = async () => {
      await deleteDoc();
      // 刪除firestore的資料及storage中的圖片檔案
      // 刪除對應path中的檔案
      await deleteImag(document.value.filepath);
      router.push({ name: "Home"});
    };
    const deleteSong = async (songid) => {
      const del = document.value.songs.filter((item) => item.id !== songid);
      await updateDoc({songs: del});
    };
    return { error, document, ownerShip, deleteplaylist, deleteSong }
  }
}
</script>

<style>
  .playlist-details {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 80px;
  }
  .cover {
    overflow: hidden;
    position: relative;
    border-radius: 20px;
    padding: 160px;
  }
  .cover img {
    display: block;
    position: absolute;
    min-width: 100%;
    max-width: 200%;
    min-height: 100%;
    max-height: 200%;
    left: -30%;
    top: -10%;
  }
  .playlist-info {
    text-align: center;
  }
  .playlist-info h2 {
    text-transform: capitalize;
    font-size: 28px;
    margin-top: 20px;
  }
  .playlist-info p {
    margin-bottom: 20px;
  }
  .username {
    color: #999;
  }
  .description {
    text-align: left;
  }
  .single-song {
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px dashed var(--secondary);
    margin-bottom: 20px;
  }
  @media only screen and (max-width: 730px) {
    .playlist-details {
      gap: 20px;
    }
  }
  @media only screen and (max-width: 590px) {
    .playlist-details {
      grid-template-columns: 100%;
      gap: 20px;
    }
  }
</style>